<template>
  <div>
    <!--  '全名罗马字编辑'-->
    <el-dialog :title="$t('message.editFullNameInRomanji')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="388px" center>
      <div class="content">
        <el-input v-model="detail.name_roma" onfocus="this.select()" type="textarea"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        name_roma: this.detail.name_roma,
      };
      this.$api.clienteleApi.updateUserNameRoma(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });

    },
  },
};
</script>
<style lang='scss' scoped>
.content {

  width: 100%;

  /deep/.el-textarea__inner {
    width: 100% !important;
  }
}
</style>